// extracted by mini-css-extract-plugin
export default {"appHeader":"AppLayoutHeader_appHeader__z3Gla"};